let language = {
    "4000032": "调用运费定价服务失败，点击确定重试。",
    "4000033": "调用运费定价服务失败，点击确定重试。",
    "4000041": "调用运费定价服务失败，点击确定重试。"
};

export { language }
